import moment from "moment";
export const formatDateToTimePeriod = (date, increment) => {
    if (increment) {
        const updatedDate = new Date(new Date(date).setHours(new Date(date).getHours() + increment));
        return moment(updatedDate).fromNow();
    }
    return moment(date).fromNow();
};
export const formatDateMMDDYYYY = (date) => moment(date).format("MM/DD/YYYY");
export const formatDateMMMDYYYY = (date) => moment(date).format("MMM D, YYYY");
//# sourceMappingURL=time-helpers.js.map